// How Spark displays a person from the genesis schema.
//
// Names in genesis are split into `name.given[]` + `name.family`, with
// `formattedName` as a server-rendered fallback. Roles are taken from
// `jobTitle` first, then `profession`. Centralising the fallback chain here
// keeps the display rule consistent everywhere a person is rendered.

export interface PersonNameFragment {
  name?: {
    given?: ReadonlyArray<string | null | undefined> | null;
    family?: string | null;
  } | null;
  formattedName?: string | null;
}

export interface PersonRoleFragment {
  jobTitle?: string | null;
  profession?: string | null;
}

export function personDisplayName(p: PersonNameFragment): string {
  const given = (p.name?.given ?? []).filter((s): s is string => Boolean(s));
  const joined = [...given, p.name?.family].filter(Boolean).join(" ");
  return joined || p.formattedName || "?";
}

export function personDisplayRole(p: PersonRoleFragment): string | null {
  return p.jobTitle || p.profession || null;
}
